import { Controller } from "@hotwired/stimulus"

// Simple toggle controller for CC input visibility
export default class extends Controller {
  static targets = ["wrapper"]

  toggle() {
    const wrapper = this.wrapperTarget
    const isHidden = wrapper.style.display === "none"

    wrapper.style.display = isHidden ? "block" : "none"

    if (isHidden) {
      const input = wrapper.querySelector("input")
      if (input) input.focus()
    }
  }
}
